<template>
  <div>
    <div v-if="!data.length" class="text-center py-4 text-muted">
      <i class="fe fe-inbox" style="font-size:1.5rem; opacity:0.3;"></i>
      <p class="mt-2 mb-0 small">No data for this period.</p>
    </div>
    <apexchart v-else type="bar" :height="height" :options="chartOptions" :series="chartSeries" />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

function chartToolbar(filename) {
  return {
    show: true,
    tools: { download: true, selection: false, zoom: false, zoomin: false, zoomout: false, pan: false, reset: false },
    export: { csv: { filename: filename }, svg: { filename: filename }, png: { filename: filename } },
  };
}

export default {
  components: { apexchart: VueApexCharts },
  props: {
    data:      { type: Array,            default: function () { return []; } },
    color:     { type: String,           default: "#2563eb" },
    filename:  { type: String,           default: "chart" },
    height:    { type: [Number, String], default: 300 },
    countKey:  { type: String,           default: "count" },
    nameKey:   { type: String,           default: "name" },
    seriesName:{ type: String,           default: "Count" },
  },
  computed: {
    chartOptions() {
      const nameKey = this.nameKey;
      return {
        chart: { type: "bar", toolbar: chartToolbar(this.filename), fontFamily: "inherit" },
        plotOptions: { bar: { horizontal: true, borderRadius: 4, barHeight: "60%" } },
        dataLabels: { enabled: true, style: { fontSize: "11px" } },
        xaxis: {
          categories: this.data.map(function (d) { return d[nameKey]; }),
          labels: { style: { fontSize: "10px", colors: "#64748b" } },
        },
        colors: [this.color],
        grid: { borderColor: "#f1f5f9", strokeDashArray: 4 },
        tooltip: { y: { formatter: function (v) { return v.toLocaleString(); } } },
      };
    },
    chartSeries() {
      const key = this.countKey;
      const name = this.seriesName;
      return [{ name: name, data: this.data.map(function (d) { return Number(d[key] || 0); }) }];
    },
  },
};
</script>
